var map = {
	"./components/advisor/dev.vue": [
		"ad08",
		"chunk-9fbf02c8"
	],
	"./components/advisor/index.vue": [
		"c412",
		"chunk-2d216b08"
	],
	"./components/advisor/subcomponents/Chat/index.vue": [
		"dc50",
		"chunk-0035fbe6"
	],
	"./components/advisor/subcomponents/Schedule/index.vue": [
		"d9fa",
		"chunk-4f32c61c",
		"chunk-2d237151",
		"chunk-22206eb1"
	],
	"./components/chat/ChatContact.vue": [
		"d4ce",
		"chunk-2d21e5a8"
	],
	"./components/chat/ChatLog.vue": [
		"d8af",
		"chunk-2d21f46f"
	],
	"./components/chat/ChatNavbar.vue": [
		"963e",
		"chunk-2d0e5b65"
	],
	"./components/chat/UserProfile.vue": [
		"242b",
		"chunk-a2881802"
	],
	"./components/chat/engine/index.vue": [
		"b433",
		"chunk-604119ed"
	],
	"./components/chat/index.vue": [
		"ba72",
		"chunk-4f32c61c",
		"chunk-604119ed",
		"chunk-7c3888a6"
	],
	"./components/chat/sidebar.vue": [
		"e85a",
		"chunk-4f32c61c",
		"chunk-604119ed",
		"chunk-0aac606e"
	],
	"./components/chat/ui/ChatMember.vue": [
		"4186",
		"chunk-2d0c0331"
	],
	"./components/chat/ui/ChatMemberAvatar.vue": [
		"746b",
		"chunk-20b1bc4e"
	],
	"./components/chat/ui/ChatMessage.vue": [
		"5c5f",
		"chunk-4f32c61c",
		"chunk-08c62c44"
	],
	"./components/chat/ui/ChatUI-Common.vue": [
		"28f3",
		"chunk-2d0b3a49"
	],
	"./components/classroom-stats/dev.vue": [
		"3c09",
		"chunk-b4d7df26"
	],
	"./components/classroom-stats/index.vue": [
		"3b8f",
		"chunk-31aed189"
	],
	"./components/classroom-stats/subcomponents/StudentAccessHeatmap.vue": [
		"cbfb",
		"chunk-35279913",
		"chunk-f48b8124"
	],
	"./components/classroom-stats/subcomponents/StudentInEachUnit.vue": [
		"2543",
		"chunk-35279913",
		"chunk-2d0b28f8"
	],
	"./components/classroom-stats/subcomponents/TotalStudent.vue": [
		"ba48",
		"chunk-35279913",
		"chunk-1edc9853"
	],
	"./components/communication/dev.vue": [
		"34f7",
		"chunk-427a405f"
	],
	"./components/communication/example/EmailMailCard.vue": [
		"036b",
		"chunk-2d0a3925"
	],
	"./components/communication/example/EmailSidebar.vue": [
		"22a1",
		"chunk-6e83591c",
		"chunk-6f640aec",
		"chunk-43a8a956",
		"chunk-41a104c1"
	],
	"./components/communication/example/EmailView.vue": [
		"be41",
		"chunk-5332c8e6"
	],
	"./components/communication/example/MailItem.vue": [
		"1f32",
		"chunk-2d0b6c6a"
	],
	"./components/communication/example/index.vue": [
		"da2f",
		"chunk-5332c8e6",
		"chunk-43119527"
	],
	"./components/communication/index.vue": [
		"18ad",
		"chunk-1693b4d3",
		"chunk-2d0d6f81"
	],
	"./components/communication/subcomponents/Chat/MessageCard.vue": [
		"6a03",
		"chunk-ef4208fa"
	],
	"./components/communication/subcomponents/Chat/MessageHeader.vue": [
		"7a32",
		"chunk-2d0e13df"
	],
	"./components/communication/subcomponents/Chat/MessageList.vue": [
		"dae2",
		"chunk-f2d280ca"
	],
	"./components/communication/subcomponents/Chat/TopicCard--OLD.vue": [
		"e90f",
		"chunk-4670fcf2"
	],
	"./components/communication/subcomponents/Chat/TopicHeader.vue": [
		"c0c7",
		"chunk-2d216217"
	],
	"./components/communication/subcomponents/Chat/TopicPage.vue": [
		"07f8",
		"chunk-72341d08"
	],
	"./components/communication/subcomponents/CommonTopicListItem.vue": [
		"6751",
		"chunk-5d43f072"
	],
	"./components/communication/subcomponents/MessageCard_PROTO.vue": [
		"7377",
		"chunk-2d0d67b2"
	],
	"./components/communication/subcomponents/MessageListItem.vue": [
		"bbdd",
		"chunk-718bc452"
	],
	"./components/communication/subcomponents/PM/MessageHeader.vue": [
		"6be3",
		"chunk-2d0da950"
	],
	"./components/communication/subcomponents/PM/MessageList.vue": [
		"f627",
		"chunk-2908ea5a"
	],
	"./components/communication/subcomponents/PM/TopicHeader.vue": [
		"f775",
		"chunk-2d22d425"
	],
	"./components/communication/subcomponents/PM/TopicList.vue": [
		"e9dc",
		"chunk-38e3a604"
	],
	"./components/communication/subcomponents/PM/TopicPage.vue": [
		"46ae",
		"chunk-5a5e2751"
	],
	"./components/communication/subcomponents/Sidebar.vue": [
		"8fd0",
		"chunk-71f4fc7a"
	],
	"./components/communication/subcomponents/TopicListControl.vue": [
		"623d",
		"chunk-6859aa07"
	],
	"./components/communication/subcomponents/TopicPageController.vue": [
		"e4f2",
		"chunk-b566d0d6"
	],
	"./components/communication/subcomponents/Webboard/MessageCard.vue": [
		"a7f0",
		"chunk-2d2093f6"
	],
	"./components/communication/subcomponents/Webboard/MessageHeader.vue": [
		"80b3",
		"chunk-2d0dd5ff"
	],
	"./components/communication/subcomponents/Webboard/MessageList.vue": [
		"2cbb",
		"chunk-a786973a"
	],
	"./components/communication/subcomponents/Webboard/TopicCard.vue": [
		"d810",
		"chunk-2d21ee69"
	],
	"./components/communication/subcomponents/Webboard/TopicHeader.vue": [
		"5a92",
		"chunk-2d0d2bdb"
	],
	"./components/communication/subcomponents/Webboard/TopicList.vue": [
		"603f",
		"chunk-73ebb3d8"
	],
	"./components/liveclass/dev.vue": [
		"eb36",
		"chunk-2d2300b6"
	],
	"./components/liveclass/index.vue": [
		"1932",
		"chunk-2d0ac37d"
	],
	"./dev-components/Debugger/index.vue": [
		"999e",
		"chunk-4b6c83ec"
	],
	"./dev-components/DevNotes/index.vue": [
		"2e4e",
		"chunk-2d0bdd5a"
	],
	"./dev-components/DeveloperTool/index.vue": [
		"64b8",
		"chunk-62ee49cc"
	],
	"./index.vue": [
		"3fc1",
		"chunk-6e83591c",
		"chunk-4cf619e8",
		"chunk-0b81cdc3"
	],
	"./layouts.vue": [
		"9663",
		"chunk-9f7c9128",
		"chunk-1914d904"
	],
	"./main.vue": [
		"034a",
		"chunk-6e83591c",
		"chunk-4cf619e8",
		"chunk-2d0a38e6"
	],
	"./views/Main/index.vue": [
		"5323",
		"chunk-2d0c7e55"
	],
	"./views/pages/Advisor/dev.vue": [
		"00d6",
		"chunk-2d0a3348"
	],
	"./views/pages/Advisor/index.vue": [
		"ab1d3",
		"chunk-7704b649"
	],
	"./views/pages/ClassroomStats/dev.vue": [
		"cbe6",
		"chunk-2d221e06"
	],
	"./views/pages/ClassroomStats/index.vue": [
		"d45a",
		"chunk-2d21e012"
	],
	"./views/pages/CommunicationCenter/dev.vue": [
		"f7a4",
		"chunk-2d22d93a"
	],
	"./views/pages/CommunicationCenter/index.vue": [
		"a476",
		"chunk-2d208308"
	],
	"./views/pages/LiveClass/dev.vue": [
		"5be2",
		"chunk-2d0d34f0"
	],
	"./views/pages/LiveClass/index.vue": [
		"233b",
		"chunk-2d0b2186"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3715";
module.exports = webpackAsyncContext;